import { render, staticRenderFns } from "./month-statistics.vue?vue&type=template&id=6a790479"
import script from "./month-statistics.vue?vue&type=script&lang=js"
export * from "./month-statistics.vue?vue&type=script&lang=js"
import style0 from "./month-statistics.vue?vue&type=style&index=0&id=6a790479&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports